import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import App from './components/App';
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <SettingsProvider>
        <App />
      </SettingsProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);